import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import {Card} from "antd";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import DeviceCreateEdit from "../../app/device/DeviceCreateEdit";
import {useEffect} from "react";
import AppConfig from "../../core/service/AppConfig";

export default function DeviceCreateEditPage()
{
    const {t} = useTranslation();
    const {deviceId} = useParams();

    useEffect(() => {
        document.title = `${deviceId ? t('Edit Device') : t('Create Device')} | ${AppConfig.getRisTitle()}`
    }, [deviceId]);

    return (
        <>
            <LayoutWithSider>
                <Card title={deviceId ? t('Edit Device') : t('Create Device')}>
                    <DeviceCreateEdit deviceId={deviceId} />
                </Card>
            </LayoutWithSider>
        </>
    )
}
